import React from "react";
import ReactECharts from "echarts-for-react";
import utils from "utils";
const IndividualVitalChart = ({
  seriesData,
  xAxisData,
  labelUnit,
  chartIndex,
}) => {
  const colors = [
    ["#5470C6", "#91CC75"],
    ["#FAC858", "#EE6666"],
    ["#73C0DE", "#3BA272"],
    ["#FC8452", "#9A60B4"],
    ["#EA7CCC", "#5470C6"],
    ["#91CC75", "#FAC858"],
    ["#EE6666", "#73C0DE"],
    ["#3BA272", "#FC8452"],
    ["#9A60B4", "#EA7CCC"],
  ];

  const colorSet = colors[chartIndex % colors.length];

  const calculateChartWidth = () => {
    const baseWidthPerDataPoint = 100; // Adjust as needed based on the data and label length
    const minWidth = 800; // Minimum width to ensure readability
    const calculatedWidth = xAxisData.length * baseWidthPerDataPoint;
    return calculatedWidth > minWidth ? calculatedWidth : minWidth;
  };

  const option = {
    color: colorSet,
    tooltip: {
      trigger: "axis",
      formatter: (params) => {
        let tooltip =
          `${utils.FormatDate(
            params[0].axisValueLabel,
            "TIME_1"
          )},${utils.FormatDate(params[0].axisValueLabel, "DATE_14")}` +
          "<br/>";
        params.forEach((item) => {
          tooltip += `${item.marker} ${item.seriesName}: ${item.data} ${
            labelUnit[item.seriesName] || ""
          }<br/>`;
        });
        return tooltip;
      },
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      axisLabel: {
        interval: 0,
        margin: 10,
        formatter: (value) =>
          `${utils.FormatDate(value, "TIME_1")},\n${utils.FormatDate(
            value,
            "DATE_14"
          )}`,
      },
    },
    yAxis: {
      type: "value",
      min: (value) => (value.min - value.min * 0.06).toFixed(2),
      max: (value) => (value.max + value.max * 0.06).toFixed(2),
    },
    legend: {
      data: seriesData.flatMap((series) =>
        series.name === "Blood Pressure"
          ? ["Systolic Blood Pressure", "Diastolic Blood Pressure"]
          : [series.name]
      ),
      // left: "left",
    },
    // grid: {
    //   containLabel: true, // Make sure the chart content fits within the container
    //   top: 30,
    //   left: 10,
    //   right: 10,
    //   bottom: 30,
    // },
    series: seriesData.flatMap((series, index) => {
      if (series.name === "Blood Pressure") {
        return [
          {
            name: "Systolic Blood Pressure",
            type: "bar",
            data: series.data.map((point) => point.value[0]),
            itemStyle: { color: colorSet[0] },
            markPoint:
              xAxisData.length > 1
                ? {
                    data: [
                      {
                        coord: [
                          xAxisData.length - 1,
                          series.data[series.data.length - 1].value[0],
                        ],
                        name: "Systolic Last Point",
                        value: `${
                          series.data[series.data.length - 1].value[0]
                        } ${labelUnit["Systolic Blood Pressure"] || ""}`,
                        symbol: "circle",
                        symbolSize: 0,
                        label: {
                          show: true,
                          position: "top",
                          distance: 0,
                        },
                        itemStyle: {
                          borderType: "solid",
                        },
                      },
                    ],
                  }
                : null,
          },
          {
            name: "Diastolic Blood Pressure",
            type: "bar",
            data: series.data.map((point) => point.value[1]),
            itemStyle: { color: colorSet[1] },
            markPoint:
              xAxisData.length > 1
                ? {
                    data: [
                      {
                        coord: [
                          xAxisData.length - 1,
                          series.data[series.data.length - 1].value[1],
                        ],
                        name: "Diastolic Last Point",
                        value: `${
                          series.data[series.data.length - 1].value[1]
                        } ${labelUnit["Diastolic Blood Pressure"] || ""}`,
                        symbol: "circle",
                        symbolSize: 0,
                        label: {
                          show: true,
                          position: "top",
                          distance: 0,
                        },
                        itemStyle: {
                          borderType: "solid",
                        },
                      },
                    ],
                  }
                : null,
          },
        ];
      } else {
        return {
          name: series.name,
          type: series.type,
          data: series.data.map((point) => point),
          itemStyle: { color: colorSet[0] },
          markPoint:
            xAxisData.length > 1
              ? {
                  data: [
                    {
                      coord: [
                        xAxisData.length - 1,
                        series.data[series.data.length - 1],
                      ],
                      name: `${series.name} Last Point`,
                      value: `${series.data[series.data.length - 1]} ${
                        labelUnit[series.name] || ""
                      }`,
                      symbol: "circle",
                      symbolSize: series.type == "bar" ? 7 : 7,
                      label: {
                        show: true,
                        position: series.type == "bar" ? "top" : "right",
                        distance: 0,
                      },
                      itemStyle: {
                        borderType: "solid",
                      },
                    },
                  ],
                }
              : null,
        };
      }
    }),
  };

  return (
    <div
      style={{
        width: "100%",
        height: "200px",
        overflowX: "auto",
      }}
    >
      <ReactECharts
        option={option}
        style={{
          width: calculateChartWidth(),
          height: "100%",
          minWidth: "100%",
        }}
      />
    </div>
  );
};

export default IndividualVitalChart;
